<template>
  <div id="modalVideoPlayer">
    <ModalBox :showModal.sync="showModal" width="946px">
      <template slot="header">
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{ $t("Video_Tutorial") }}</h2>
          <p class="textBlue cursorPointer" @click="HideModal()">{{ $t("Default_View") }}</p>
        </div>
      </template>
      <template slot="body">
        <div class="boxcontent">
          <div class="sideBar">
            <div class="menu">
              <div
                class="listMenu"
                v-for="(youtubeItem, index) in youtubeUrlList"
                :key="index + 'youtubeItem'"
                @click="ShowVideo(index)"
              >
                <p :class="{ textBold: youtubeItem.isShow }">{{ youtubeItem.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="body">
          <div class="video" v-if="iframe" v-html="iframe"></div>
          <div class="contentFeedback" v-if="!isMUZE">
            <hr
              class="my-4"
              v-if="
                currentYoutubeItem.isSendFeedback === videoFeedback.None ||
                  currentYoutubeItem.isSendFeedback === videoFeedback.Complete
              "
            />
            <div v-if="currentYoutubeItem.isShow && currentYoutubeItem.isSendFeedback === videoFeedback.None">
              <h4 class="h6 text-center mb-3">{{ $t("Video_Feedback.Large.Header") }}</h4>
              <div class="d-flex justify-content-center">
                <p
                  class="mr-5 thumsUp border rounded p-2"
                  @click="$emit('SendFeedback', videoIndex, videoFeedback.Yes)"
                >
                  <i class="fas fa-thumbs-up "></i>
                  {{ $t("Video_Feedback.Large.Yes") }}
                </p>
                <p class="thumsDown border rounded p-2" @click="$emit('SendFeedback', videoIndex, videoFeedback.No)">
                  <i class="fas fa-thumbs-down "></i> {{ $t("Video_Feedback.Large.No") }}
                </p>
              </div>
            </div>
            <div
              class="mb-3 border rounded p-3"
              v-if="currentYoutubeItem.isShow && currentYoutubeItem.isSendFeedback === videoFeedback.No"
            >
              <h4 class="h6 mb-2">{{ $t("Video_Feedback.Large.Question") }}</h4>
              <CheckBox
                :label="$t('Video_Feedback.Large.No_Choice.Not_Understand')"
                :checked.sync="feedbackSelectedChoice.notUnderstand"
                styleLabel="font-size:14px"
              />
              <CheckBox
                :label="$t('Video_Feedback.Large.No_Choice.Not_Sovle_Issues')"
                :checked.sync="feedbackSelectedChoice.notSovleIssues"
                styleLabel="font-size:14px"
              />
              <CheckBox
                :label="$t('Video_Feedback.Large.No_Choice.Video_Need_More_Info')"
                :checked.sync="feedbackSelectedChoice.videoNeedMoreInfo"
                styleLabel="font-size:14px"
              />
              <CheckBox
                :label="$t('Video_Feedback.Large.No_Choice.Video_Too_Much_Info')"
                :checked.sync="feedbackSelectedChoice.videoTooMuchInfo"
                styleLabel="font-size:14px"
              />
              <CheckBox
                :label="$t('Video_Feedback.Large.No_Choice.Other')"
                :checked.sync="feedbackSelectedChoice.other"
                styleLabel="font-size:14px"
              />
              <TextArea
                width="100%"
                class=""
                v-if="feedbackSelectedChoice.other"
                :label="$t('Video_Feedback.Large.Other')"
                :placeholder="$t('Video_Feedback.Large.Other_Placeholder')"
                :value="feedbackOtherMessage"
                @input="$emit('update:feedbackOtherMessage', $event)"
                maxlength="500"
              />
              <div class="mt-2 d-flex justify-content-end">
                <buttonStyle
                  height="32px"
                  width="120px"
                  styleButton="primary"
                  theme="mint"
                  :text="$t('Video_Feedback.Large.Submit')"
                  textSize="14px"
                  :disabled="feedbackOtherMessage.length > 500"
                  @click="$emit('SendFeedback', videoIndex, videoFeedback.Submit)"
                />
              </div>
            </div>
            <div v-if="currentYoutubeItem.isShow && currentYoutubeItem.isSendFeedback === videoFeedback.Complete">
              <p class="text-center my-3">{{ $t("Video_Feedback.Large.Thank_You") }}</p>
            </div>
          </div>
        </div>
      </template>
    </ModalBox>
  </div>
</template>

<script>
import { VideoFeedback } from "@/enums/enums";
import { CheckIsMUZE } from "@/helper/shareHelper";

const IsMUZE = CheckIsMUZE();
export default {
  props: {
    youtubeUrlList: {
      type: Array,
    },
    feedbackSelectedChoice: {
      type: Object,
    },
    feedbackOtherMessage: {
      type: String,
    },
    userFeedbackVideo: {
      type: Array,
    },
  },
  created() {
    if (this.youtubeUrlList && this.youtubeUrlList.length > 0) {
      const index = this.youtubeUrlList.findIndex((x) => x.isShow);
      if (index > -1) {
        this.ShowVideo(index);
      } else {
        this.youtubeUrlList[0].isShow = true;
        this.SetIframe(this.youtubeUrlList[0].url);
        this.currentYoutubeItem = this.youtubeUrlList[0];
      }
    }
  },
  data() {
    return {
      showModal: true,
      iframe: "",
      videoIndex: 0,
      currentYoutubeItem: {},
      videoFeedback: VideoFeedback,
      isMUZE: IsMUZE,
    };
  },
  watch: {
    showModal(newValue, oldValue) {
      if (!newValue) {
        this.HideModal();
      }
    },
    userFeedbackVideo() {
      const index = this.youtubeUrlList.findIndex((x) => x.isShow);
      if (index > -1) {
        this.ShowVideo(index);
      }
    },
  },
  methods: {
    HideModal() {
      this.$emit("update:showModal", false);
    },
    ShowVideo(youtubeIndexItem) {
      this.youtubeUrlList.forEach((youtube, index) => {
        youtube.isSendFeedback = VideoFeedback.None;
        if (index == youtubeIndexItem) {
          this.SetIframe(youtube.url);
          youtube.isShow = true;
          this.videoIndex = youtubeIndexItem;
          this.currentYoutubeItem = youtube;
          if (this.CheckIsAlreadySendFeedbackVideo(youtube.url)) {
            youtube.isSendFeedback = VideoFeedback.Complete;
          }
          this.$emit("SetSelectedChoiceDefault");
        } else {
          youtube.isShow = false;
        }
      });
    },
    SetIframe(url) {
      this.iframe = `<iframe width="700" height="400" src="${url}" title="YouTube video player" frameborder="0"  clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    },
    CheckIsAlreadySendFeedbackVideo(url) {
      return this.userFeedbackVideo.filter((feedback) => feedback.url === url).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@include videoFeedback;
#modalVideoPlayer {
  .boxcontent {
    display: flex;

    .sideBar {
      border-right: 1px solid #ffffff;
      margin-right: 0px;
      transition: 0.25s;
      width: 0px;
      height: 0px;
      overflow: hidden;
      width: 270px;
      height: auto;
      > .menu {
        position: fixed;
      }
      .listMenu {
        padding: 5px 0px;
        background: white;
        cursor: pointer;
        width: 190px;
        transition: 0.25s;

        p {
          color: $text;
        }
        &:hover {
          padding: 5px 5px;
          border-radius: 4px;
          background: #f2f2f2;
          p {
            color: $text;
          }
        }
      }
    }
  }
  .body {
    width: 100%;
    margin-left: 200px;
    .contentFeedback {
      max-width: 700px;
    }

    .video {
      width: 700px;
      height: 400px;
      overflow: hidden;
      @include shadowboxLv2;
      border-radius: 10px;
      margin-bottom: 8px;
    }
  }
}
</style>
